import EventContent from './EventContent';

export default EventContent;
